import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Pedestrian20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M9.44043 6.3313C9.97136 6.24281 10.513 6.41652 10.8936 6.79712L12.4287 8.33325H14.584C14.5839 9.25361 13.8374 9.99927 12.917 9.99927H11.7393L10.834 9.16626L10.2871 10.6838L12.0117 12.4983L12.917 16.6663C12.0199 16.8654 11.1321 16.2968 10.9375 15.3987L10.4902 13.3342L9.32422 12.1682L7.91699 16.6663C7.03779 16.3985 6.54419 15.4673 6.81543 14.5891L8.8125 8.12622L7.99414 8.26196L7.45215 9.07544C6.94155 9.84127 5.90649 10.0479 5.14062 9.53735L7.00781 6.73657L9.44043 6.3313ZM11.251 3.33325C11.9412 3.33343 12.501 3.893 12.501 4.58325C12.501 5.2735 11.9412 5.83308 11.251 5.83325C10.5606 5.83325 10.001 5.27361 10.001 4.58325C10.001 3.8929 10.5606 3.33325 11.251 3.33325Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
